import {
    Badge,
    Tooltip,
} from '@mantine/core';

import {
    DefectSignature,
    DefectStatus,
} from '../types';
import {
    classifyDefect,
    DefectKind,
    defectKindDisplay,
    defectStatusDisplay,
} from '../utils/classifyDefect';

// The signal badge is the load-bearing one: it is what stops NOT_VERIFIED
// reading like an ordinary failure. See classifyDefect for why that distinction
// is the point of the module rather than a styling preference.
export const DefectSignalBadge = ({
                                      record,
                                      kind,
                                  }: {
    record: Pick<DefectSignature, 'status' | 'outcome' | 'verificationResult' | 'lastSeenAt' | 'resolvedAt'>,
    kind?: DefectKind,
}) => {
    const resolved = kind ?? classifyDefect(record);
    const display = defectKindDisplay(resolved);

    return (
        <Tooltip label={display.description} multiline w={300} withArrow>
            <Badge
                color={display.color}
                variant={display.muted ? 'light' : 'filled'}
            >
                {display.label}
            </Badge>
        </Tooltip>
    );
};

// Triage state — where a HUMAN has taken this. Kept visually separate from the
// signal badge because they answer different questions: "how bad is it?" versus
// "has anyone dealt with it?". A NEW regression and a FILED regression are very
// different situations.
export const DefectStatusBadge = ({status}: { status: DefectStatus }) => {
    const display = defectStatusDisplay(status);

    return (
        <Badge color={display.color} variant={'outline'}>
            {display.label}
        </Badge>
    );
};
